import { RodzajProjektu } from '../rodzajProjektu';
import { PoleSpisu } from './poleSpisu';

export class PolaSpisuProjektu {
  projektId: string;
  nazwaProjektu: string;
  pola: Array<PoleSpisu> = new Array();
  czyJestImportEwidencji: boolean;
  rodzajProjektu: RodzajProjektu;
  czySpisSamodzielnyKlienta: boolean;
}
